import React, { useState } from "react";
import { UseAndInvestmentTerms } from "..";
import CustomModal from "../customModal";

const FooterNav = () => {
  const [show, setShow] = useState(false);

  const handleShow = () => setShow(!show);

  return (
    <>
      <div className="col-md-4 g-mb-10 g-mb-0--md">
        <ul className="list-inline text-center text-md-left mb-0">
          <li className="list-inline-item">
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                handleShow();
              }}
            >
              Termos de Investimento
            </a>
          </li>
        </ul>
      </div>

      <CustomModal
        show={show}
        header="Termos de Uso e Investimento"
        onHide={handleShow}
        backdrop
        keyboard
        size="lg"
      >
        <UseAndInvestmentTerms />
      </CustomModal>
    </>
  );
};

export default FooterNav;
